/**
 * Luxury FAQ Accordion Component
 * OnlyPaithani - Impulse Theme
 */
(function() {
  'use strict';

  class LuxuryFAQ {
    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('.luxury-faq__button');
      this.items = container.querySelectorAll('.luxury-faq__item');
      
      if (!this.buttons.length) return;

      this.init();
    }

    init() {
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', (e) => this.toggleItem(e.currentTarget));
        
        button.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextButton = this.buttons[(index + 1) % this.buttons.length];
            nextButton.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevButton = this.buttons[(index - 1 + this.buttons.length) % this.buttons.length];
            prevButton.focus();
          }
        });
      });
    }

    toggleItem(targetButton) {
      const isExpanded = targetButton.getAttribute('aria-expanded') === 'true';
      const targetPanelId = targetButton.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetPanelId);
      const targetItem = targetButton.closest('.luxury-faq__item');

      // Close all other items (Single open item policy)
      this.buttons.forEach(button => {
        if (button !== targetButton) {
          button.setAttribute('aria-expanded', 'false');
          const panelId = button.getAttribute('aria-controls');
          const panel = document.getElementById(panelId);
          const item = button.closest('.luxury-faq__item');
          if (panel) {
            panel.style.maxHeight = null;
            panel.setAttribute('hidden', '');
          }
          if (item) {
            item.classList.remove('luxury-faq__item--open');
          }
        }
      });

      // Toggle clicked item
      if (isExpanded) {
        targetButton.setAttribute('aria-expanded', 'false');
        if (targetPanel) {
          targetPanel.style.maxHeight = null;
          targetPanel.setAttribute('hidden', '');
        }
        if (targetItem) {
          targetItem.classList.remove('luxury-faq__item--open');
        }
      } else {
        targetButton.setAttribute('aria-expanded', 'true');
        if (targetPanel) {
          targetPanel.removeAttribute('hidden');
          targetPanel.style.maxHeight = targetPanel.scrollHeight + 'px';
        }
        if (targetItem) {
          targetItem.classList.add('luxury-faq__item--open');
        }
      }
    }
  }

  function initLuxuryFAQs() {
    const containers = document.querySelectorAll('.luxury-faq');
    containers.forEach(container => {
      if (!container.dataset.faqInitialized) {
        container.dataset.faqInitialized = 'true';
        new LuxuryFAQ(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuxuryFAQs);
  } else {
    initLuxuryFAQs();
  }

  document.addEventListener('shopify:section:load', function(event) {
    const container = event.target.querySelector('.luxury-faq');
    if (container) {
      container.dataset.faqInitialized = 'true';
      new LuxuryFAQ(container);
    }
  });
})();
